import { ProductMetafields } from "~/types";

export function SetupProductRequestForm({ product }: { product: ProductMetafields }) {
    return (<></>)
}